
<template>
  <div>
    <template v-if="!loading && stages.length">
      <draggable v-model="stages" v-bind="dragOptions" @change="reorder" @start="handleDragStart" @end="handleDragStop" draggable=".bacon" handle=".handle">
        <transition-group type="transition" :name="!is_dragging ? 'flip-list' : null">
          <show-one-stage v-for="(stage, idx) in stages" :key="stage.id" class="my-2 bacon handle" :style="{cursor: is_dragging? 'grabbing':'grab'}"
            :position="idx+1" :max_positions="stages.length" :stage="stage"
            @updatedStage="handleUpdatedStage"
          ></show-one-stage>
        </transition-group>
      </draggable>

    </template>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import request_error_catch from '@/mixins/request_error_catch'
import draggable_helpers from '@/mixins/draggable_helpers'
import Api from '@/api/index';
import ShowOneStage from './ShowOneStage.vue';

export default {
  name: 'ProjectStagesList',
  mixins: [ draggable_helpers, request_error_catch ],
  components: {
    ShowOneStage,
    //ComponentName: () => import(''),
  },
  data() {
    return {
      loading: false,

      stages: [],
      stages_bkp: [],

    }
  },
  methods: {
    reorder(){
      let obj = {
        id: this.$route.params.id,
        stages_attributes: this.stages.map((t, idx)=> {return {id: t.id, position: idx + 1, name: t.name}})
      }
      Api.Project.update(obj).then(r=>r.data).then(d=> {
      }).catch(err=> {
        console.log({err});
        this.catch_error(err)
      }).finally(()=> {

      })
    },
    handleUpdatedStage(e){
      const idx = this.stages.findIndex(({id})=> id == e.id)
      if (idx > -1){
        this.stages.splice(idx, 1, {...e})
      }
      this.stages = this.stages.sort((a,b) => Number(a.position) - Number(b.position))
    },
    getStages() {
      this.loading = true
      Api.Stage.index({project_id: this.$route.params.id, use_type: ['official'], sorts: {position: 'asc'}}).then(r=>r.data).then(d=> {
        this.stages = [...d]
        this.stages_bkp = [...d]
      }).catch(err=> {
        console.log({err});
        this.catch_error(err)
      }).finally(()=> this.loading = false)
    },
    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  mounted () {
    this.getStages();
  },
}
</script>

<style scoped>

</style>